<template lang="pug">
  v-dialog(v-model="modal", persistent, max-width="800")
    template(v-slot:activator="{ on }")
      slot(name="activator", v-bind:on="on")
    v-card
      app-entity-form(
        v-model="instance",
        :entity="entity",
        :errors="errors",
        v-bind="{ editMode }"
      )
      v-card-actions.justify-end
        v-btn(color="blue", @click="close()") Close
        v-btn(color="grey", @click="close(true)") Save
</template>

<script>
export default {
  name: 'entity-modal',
  props: {
    editMode: Boolean,
    errors: [],
    value: {
      type: Object,
      default: () => ({})
    },
    entity: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      instance: this.value,
      modal: false
    }
  },
  methods: {
    close (emit) {
      this.modal = false
      if (emit) this.$emit('input', this.instance)
    }
  }
}
</script>
